import axios from "axios"
import { Dispatch, SetStateAction } from "react"
import constants from "../../../constants"
import GroupDialog from "./GroupDialog"
import { Groups, OpenGroupModal } from "../../../types"
import { addError, addSuccess } from "../../../redux/alerts"
import { useAppDispatch } from "../../../redux/store"

type CreateGroupDialogProps = {
  open: boolean,
  customerNumber: string,
  setOpenModal: Dispatch<SetStateAction<OpenGroupModal>>,
  setGroupId: Dispatch<SetStateAction<number | null>>,
}

const createCustomerGroup = async (groupName: string, customerNumber: string) => {
  const response = await axios.post(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/groups`, {
    name: groupName.trim(),
  })
  
  return response.data
}

const CreateGroupDialog = (props: CreateGroupDialogProps) => {
  const { open, setOpenModal, customerNumber, setGroupId } = props
  const dispatch = useAppDispatch()

  const handleSuccess = (group: Groups) => {
    const groupId = group?.group_id ?? null
    const groupName = group?.name

    setGroupId(groupId)
    dispatch(addSuccess(`Group ${groupName} created`))
  }

  const handleError = () => {
    dispatch(addError('There was a problem creating the group'))
  }

  const handleClose = () => {
    setOpenModal({ open: false, type: 'create' })
  }

  return (
    <GroupDialog
      open={open}
      customerNumber={customerNumber}
      title="Create Group"
      saveText="Create"
      defaultGroupName=""
      icon="plus"
      handleClose={handleClose}
      handleSuccess={handleSuccess}
      handleError={handleError}
      service={createCustomerGroup}
    />
  )
}

export default CreateGroupDialog
